import React from 'react';
import styled, { ThemeConsumer } from 'styled-components';

import { DashedButton as DesignDashedButton, IconActionPlus } from 'wg-fe-ui';

interface Props {
  label: string;
  onClick: () => void;
}

const DashedButton: React.FC<React.PropsWithChildren<Props>> = ({
  label,
  onClick,
  ...otherProps
}) => {
  return (
    <ThemeConsumer>
      {(theme) => (
        <Wrapper
          button={
            <CircularButton>
              <IconActionPlus color={theme.ui.outline} />
            </CircularButton>
          }
          label={label}
          onClick={onClick}
          styleName="normal"
          data-test-id="ProdFac_DashedButton"
          {...otherProps}
        />
      )}
    </ThemeConsumer>
  );
};

const CircularButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5rem;
  height: 5rem;
  padding: 0.8rem;
  border: none;
  border-radius: 2.5rem;
  background-color: #f6f6f6;

  > svg {
    width: 100%;
    height: 100%;
  }
`;

const Wrapper = styled(DesignDashedButton)`
  padding: 4rem;
  transition: 0.2s;
  > div:last-child {
    color: ${({ theme }) => theme.ui.outline};
  }

  &:hover {
    > button {
      background-color: ${({ theme }) => theme.primary[500]};
      transition: 0.2s;
      cursor: pointer;

      > svg > path {
        fill: white;
      }
    }

    > div:last-child {
      color: black;
    }
  }
`;

export default DashedButton;
